module.exports = "../../app/cells/components/campaigns/interventions/products_hero/hero_lot/show.erb";